import React from 'react';
import styled from 'styled-components';
import { Card } from './styled';
import { TYPE } from 'theme';

const Footer = styled.div`
    position: sticky;
    bottom: 20px;
    border-radius: 20px;
    color: #000;
    width: 240px;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        bottom: 80px;
    `};

    ${({ theme }) => theme.mediaWidth.upToSmall`
        position: unset;
        left: unset;
        bottom: unset;
        margin: 20px 0;
        width: 100%;
    `};
`;

const Version = styled.span`
    font-size: 10px;
    background: ${({ theme }) => theme.c.primary02};
    border-radius: 4px;
    color: #fff;
    padding: 2px 4px;
`;

const VERSION = process.env.REACT_APP_VERSION || '';

const FooterCard = () => {
    return (
        <Footer>
            <Card background="transparent">
                <TYPE.desc
                    style={{ cursor: 'pointer' }}
                    fontSize={14}
                    fontWeight={700}
                    onClick={() => window.open("https://docs.goat.network/users/onepiece", '_blank')}
                >
                    User Guide
                </TYPE.desc>
                <TYPE.desc fontSize={12} marginTop="6px">
                    <span>Current Version: </span>
                    <Version>{VERSION}</Version>
                </TYPE.desc>
            </Card>
        </Footer>
    );
};

export default FooterCard;
